type NavigationBackground = 'lime' | 'black' | 'taupe' | 'white' | 'beige'

interface MaterialTheme {
  mainNav: string
  textColor: string
  borderColor: string
  logoVariant: 'black' | 'white'
  megaMenuBackground: string
  buttonStyles: {
    sales: string
    signup: string
  }
}

const DEFAULT_THEME: MaterialTheme = {
  mainNav: 'bg-white',
  textColor: '',
  borderColor: '',
  logoVariant: 'black',
  megaMenuBackground: '',
  buttonStyles: { sales: '', signup: '' },
}

const themes: Record<string, MaterialTheme> = {
  lime: {
    mainNav: 'bg-civo-lime',
    textColor: '',
    borderColor: '',
    logoVariant: 'black',
    megaMenuBackground: '',
    buttonStyles: { sales: '', signup: '' },
  },
  taupe: {
    mainNav: 'bg-civo-cloud',
    textColor: '',
    borderColor: '',
    logoVariant: 'black',
    megaMenuBackground: '',
    buttonStyles: { sales: '', signup: '' },
  },
  beige: {
    mainNav: 'bg-civo-cloud',
    textColor: '',
    borderColor: '',
    logoVariant: 'black',
    megaMenuBackground: '',
    buttonStyles: { sales: '', signup: '' },
  },
  black: {
    mainNav: 'bg-civo-black',
    textColor: 'text-white',
    borderColor: '',
    logoVariant: 'white',
    megaMenuBackground: '',
    buttonStyles: { sales: '', signup: '' },
  },
}

export const getMaterialTheme = (navigationBackground: NavigationBackground): MaterialTheme => {
  return themes[navigationBackground] ?? DEFAULT_THEME
}